var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "9",
      "height": "15"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#9D9D9D",
      "fill-rule": "evenodd",
      "d": "M.714 14.04a1.015 1.015 0 0 0 1.428 0L9 7.25 2.141.46a1.015 1.015 0 0 0-1.427 0 .994.994 0 0 0 0 1.414L6.145 7.25.714 12.626a.994.994 0 0 0 0 1.414"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }